import "./style.css"
import { useState } from "react"
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

const Cart = ({ CartItem, addToCart, decreaseQty }) => {
  // Stpe: 7   calucate total of items
  const totalPrice = CartItem.reduce((price, item) => price + item.qty * item.price, 0)

  const [city, setCity] = useState('');

  const handleChange = (event) => {
    setCity(event.target.value);
  };


  const [visible, setVisible] = useState(false);

  const checkOut = ()=>{
    setVisible(true);

  }
  const closeProduct = (item)=>{
    item.qty = 0;
    // console.log(item.qty);
  } 
  // prodcut qty total
  return (
    <>
      <section className="cart-items">
        <div className="container d_flex">
          {/* if hamro cart ma kunai pani item xaina bhane no diplay */}

          <div className="cart-details">
            {CartItem.length === 0 && (
              <h1 className="no-items product">No Items are add in Cart</h1>
            )}

            {/* yasma hami le cart item lai display garaaxa */}
            {CartItem.map((item) => {
              const productQty = item.price * item.qty;

              return (
                <div className="cart-list product d_flex" key={item.id}>
                  <div className="img">
                    <img src={item.cover} alt="" className="card-image" />
                  </div>
                  <div className="cart-details">
                    <h3>{item.name}</h3>
                    <h4>
                      ${item.price}.00 * {item.qty}
                      <span>${productQty}.00</span>
                    </h4>
                  </div>
                  <div className="cart-items-function">
                    <div className="removeCart">
                      <button
                        type="button"
                        className="removeCart"
                        onClick={() => closeProduct(item)}
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                    {/* stpe: 5 
                    product ko qty lai inc ra des garne
                    */}
                    <div className="cartControl d_flex">
                      <button
                        className="incCart"
                        onClick={() => addToCart(item)}
                      >
                        <i className="fa-solid fa-plus"></i>
                      </button>
                      <button
                        className="desCart"
                        onClick={() => decreaseQty(item)}
                      >
                        <i className="fa-solid fa-minus"></i>
                      </button>
                    </div>
                  </div>

                  <div className="cart-item-price"></div>
                </div>
              );
            })}
          </div>

          {visible && totalPrice > 0 && (
            <div className="cart-details">
              {/* <h1 className="no-items product">NForm</h1> */}
              <Box
                className="no-items product"
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <h3>Fill out the form</h3>
                <TextField
                  id="first-name"
                  color="secondary"
                  label="First Name"
                  placeholder="First Name"
                  variant="filled"
                />
                <TextField
                  id="last-name"
                  color="secondary"
                  label="Last Name"
                  placeholder="Last Name"
                  variant="filled"
                />
                <TextField
                  id="phone"
                  color="secondary"
                  label="Phone Number"
                  placeholder="Phone Number"
                  variant="filled"
                />
                <TextField
                  id="email"
                  color="secondary"
                  label="Email"
                  placeholder="Email"
                  variant="filled"
                />
                <TextField
                  id="telegram"
                  color="secondary"
                  label="Telegram Username"
                  placeholder="e.g. t.me/gama1221"
                  variant="filled"
                />

                <FormControl variant="standard" sx={{ m: 1, minWidth: 280 }}>
                  <InputLabel id="input-city" color="secondary">
                    City
                  </InputLabel>
                  <Select
                    color="secondary"
                    labelId="input-city"
                    id="lbl-city"
                    value={city}
                    onChange={handleChange}
                    label="City"
                    variant="filled"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={10}>Lagos</MenuItem>
                    <MenuItem value={20}>Kano</MenuItem>
                    <MenuItem value={30}>Ibadan</MenuItem>
                    <MenuItem value={40}>Abuja</MenuItem>
                    <MenuItem value={50}>Zaria</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel color="secondary" id="demo-row-radio-buttons-group-label">
                    Payment
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="delivery"
                      control={<Radio  color="secondary"/>}
                      label="Pay upon Delivery"
                      style={{color:'black'}}
                    />
                    <FormControlLabel
                      value="credit-card"
                      control={<Radio color="secondary"/>}
                      label="Pay with Credit Card"
                      style={{color:'black'}}
                    />
                  </RadioGroup>
                </FormControl>

                <div className="checkout-order">
                  <button type="submit" className="btn-primary track-order">
                    Place Order
                  </button>
                  <button type="submit" className="btn-primary track-order" >
                   Track Order
                  </button>
                </div>
              </Box>
            </div>
          )}

          <div className="cart-total product">
            <h2>Cart Summary</h2>
            <div className=" d_flex">
              <h4>Total Price :</h4>
              <h3>${totalPrice}.00</h3>
            </div>
            <div className="checkout">
              <button
                type="submit"
                onClick={checkOut}
                className="btn-primary checkout"
              >
                Checkout
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Cart
